import styled from 'styled-components';

export const AddressCardContent = styled.div`
  display: flex;
  flex-direction: column;

  h3 {
    line-height: 24px;
    max-width: 210px;
  }
`;

export const AddressCardWrapper = styled.div<{ $isSelected: boolean }>`
  ${({ theme, $isSelected }) => `
        padding: 16px;
        display: flex;
        justify-content: space-between;
        border-radius: 12px;
        width: 342px;
        align-items: center;

        border: ${$isSelected ? 'none' : `1px solid ${theme.colors.strokeSecondaryGrey10}`};
        background: ${$isSelected ? theme.colors.backgroundSecondaryGrey05 : theme.colors.cardElevationLowWhite};
        box-shadow: ${$isSelected ? theme.elevations.extraSunken : theme.elevations.mid};

        @media screen and (${theme.breakpoints.small} < width <= ${theme.breakpoints.medium}) {
          width: 300px;
        }

        ${
          !$isSelected &&
          `
            cursor: pointer;
            
            &:hover {
                background: ${theme.colors.cardInteractionHoverGrey05};
            }

            &:active {
                background: ${theme.colors.cardInteractionActiveSecondary420};
            }
        `
        }
    `}
`;
